'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _FundName = require('./FundName.css');

var _FundName2 = _interopRequireDefault(_FundName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundName = (_dec = (0, _reactCssModules2.default)(_FundName2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundName, _Component);

  function FundName(props) {
    (0, _classCallCheck3.default)(this, FundName);
    return (0, _possibleConstructorReturn3.default)(this, (FundName.__proto__ || (0, _getPrototypeOf2.default)(FundName)).call(this, props));
  }

  (0, _createClass3.default)(FundName, [{
    key: 'render',
    value: function render() {
      var sriIcon = require('../../../static/images/sri.png');
      var ussifLogo = require('../../../static/images/ussif-icon.png');
      var shareClass = this.props.shareClass;
      var hasSRIBadge = _convert2.default.boolean(shareClass.socially_responsible_fund);
      var hasUssifBadge = _convert2.default.float(shareClass.ussif) === 1.5;
      var isTargetDate = shareClass.is_target_date;

      // 20241018
      // hack for WFF-APP
      var famUrl = _config2.default.routes.families + '?q=' + encodeURIComponent(shareClass.fund_family_name);
      if (_config2.default.app.title === 'Weapon Free Funds') {
        famUrl = _config2.default.routes.fundManager + '/' + encodeURIComponent(shareClass.fund_family_name);
      }

      var legalType = {
        'FE': 'Exchange-traded fund',
        'FO': 'Open-end mutual fund',
        'TSP': 'TSP fund',
        'VA': 'Variable annuity'
      }[shareClass.legal_type] || 'ERR';

      //
      return _react2.default.createElement(
        _components.ContainerDivs,
        null,
        _react2.default.createElement(
          'header',
          { styleName: 'fund-name-wrap' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'legalname' },
              shareClass.fund_legal_name
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'name-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'name-label' },
                'Shareclass'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'name-value' },
                shareClass.name,
                shareClass.ticker ? ' (' + shareClass.ticker + ')' : null
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'name-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'name-label' },
                'Type'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'name-value' },
                legalType
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'name-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'name-label' },
                'Manager'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'name-value' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: famUrl,
                    title: shareClass.fund_family_name
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'fund-manager-name' },
                    shareClass.fund_family_name
                  )
                )
              )
            ),
            isTargetDate ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'name-label-value' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'name-label' },
                  'Target date'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'name-value' },
                  shareClass.strategy_name
                )
              ),
              _react2.default.createElement(_components.FundTargetDateLinks, { strategyName: shareClass.strategy_name })
            ) : null
          ),
          hasSRIBadge || hasUssifBadge ? _react2.default.createElement(
            'div',
            { styleName: 'sri-icons-wrap' },
            hasSRIBadge ? _react2.default.createElement('img', {
              styleName: 'sri',
              src: sriIcon,
              alt: 'Sustainability mandate',
              'data-multiline': true,
              'data-effect': 'solid',
              'data-tip': '<div style=\'max-width:250px;\'>Reports a ' + 'Sustainability Mandate to Morningstar. ' + 'Sustainable funds consider issues like the ' + 'environment and human rights.</div>',
              'data-html': true,
              'data-place': 'bottom',
              'data-for': 'fundname-sri-tooltip'
            }) : null,
            _react2.default.createElement(_reactTooltip2.default, { id: 'fundname-sri-tooltip' }),
            hasUssifBadge ? _react2.default.createElement('img', {
              styleName: 'ussif',
              src: ussifLogo,
              alt: 'Member of US-SIF',
              'data-multiline': true,
              'data-effect': 'solid',
              'data-tip': '<div style=\'max-width:250px;\'>Member of The Forum ' + 'for Sustainable and Responsible Investment.</div>',
              'data-html': true,
              'data-place': 'bottom',
              'data-for': 'fundname-ussif-tooltip'
            }) : null,
            _react2.default.createElement(_reactTooltip2.default, { id: 'fundname-ussif-tooltip' })
          ) : null
        ),
        shareClass.fund_family_name === 'Thrift Savings Plan' ? _react2.default.createElement(_components.TspDisclaimer, { shareclass: shareClass }) : null
      );
    }
  }]);
  return FundName;
}(_react.Component), _class2.propTypes = {
  shareClass: _react.PropTypes.object.isRequired,
  pathname: _react.PropTypes.string.isRequired
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = FundName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/FundName/FundName.js
// module id = 1354
// module chunks = 0